export default __webpack_public_path__ + "static/media/Profile.7f6dcd3a.svg";